import { render, staticRenderFns } from "./uploadimg_small copy.vue?vue&type=template&id=40476b88&scoped=true&"
import script from "./uploadimg_small copy.vue?vue&type=script&lang=js&"
export * from "./uploadimg_small copy.vue?vue&type=script&lang=js&"
import style0 from "./uploadimg_small copy.vue?vue&type=style&index=0&id=40476b88&prod&lang=css&"
import style1 from "./uploadimg_small copy.vue?vue&type=style&index=1&id=40476b88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40476b88",
  null
  
)

export default component.exports